// Load dependencies
import 'angular-ui-bootstrap/src/position/position';

// Load module
import 'angular-ui-bootstrap/src/dropdown/dropdown';

// Expose the module name
export default 'ui.bootstrap.dropdown';
